/**
 * @generated SignedSource<<e2b914e1be4f798f999ca7272437f8ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedVisuallySimilarItemsCarouselLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarousel_viewer">;
  readonly " $fragmentType": "PdpSharedVisuallySimilarItemsCarouselLazy_viewer";
};
export type PdpSharedVisuallySimilarItemsCarouselLazy_viewer$key = {
  readonly " $data"?: PdpSharedVisuallySimilarItemsCarouselLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarouselLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedVisuallySimilarItemsCarouselLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedVisuallySimilarItemsCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1935173ed8e504b24c1f8a9e89870c25";

export default node;
